
import { DollarSign } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

interface PriceOption {
  label: string;
  value: string;
}

interface PriceRangeSectionProps {
  priceRangeOptions: PriceOption[];
  selectedPriceRange: string | null;
  onPriceRangeChange: (value: string) => void;
}

const PriceRangeSection = ({
  priceRangeOptions,
  selectedPriceRange,
  onPriceRangeChange
}: PriceRangeSectionProps) => {
  return (
    <div className="p-4 bg-gray-50 border-t border-gray-200 animate-accordion-down">
      <div className="flex items-center justify-between mb-2">
        <h4 className="text-xs font-medium text-gray-500">PRICE RANGE</h4>
        {selectedPriceRange && (
          <Badge variant="outline" className="bg-amber-50 text-amber-700 text-xs">
            1 selected
          </Badge>
        )}
      </div>
      <Select 
        value={selectedPriceRange || "default"} 
        onValueChange={onPriceRangeChange}
        name="price-range"
      >
        <SelectTrigger className="w-full" id="price-range-select">
          <SelectValue placeholder="Any Price Range" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="default">Any Price Range</SelectItem>
          {priceRangeOptions.map(option => (
            <SelectItem key={option.value || "price-option-key"} value={option.value || "price-option"}>
              {option.label || "Unknown Price Range"}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default PriceRangeSection;
